import React from 'react';
import {Menu} from "antd";
import {useHistory, useLocation} from "react-router-dom";
import {connect} from "react-redux";

const ExercisesNavbar = () => {
    const history = useHistory();
    const location = useLocation();

    const onClick = (item) => {
        if (item.key) {
            history.push(item.key);
        }
    }

    const parts = location.pathname.split('/');
    const root = '/' + parts[1];
    let current = '';
    for (let i = 1; i < parts.length; i++) {
        current += '/' + parts[i];
    }

    const items = [
        {
            label: 'Dźwięki',
            key: '/exercises/1',
            children: [
                {label: 'Klucze', key: '/exercises/clefs'},
                {label: 'Wartości rytmiczne', key: '/exercises/note-values'},
                {label: 'Wartości rytmiczne. Test', key: '/exercises/note-values/test'},
                {label: 'Nazwy dźwięków', key: '/exercises/notes'},
                {label: 'Nazwy dźwięków. Test', key: '/exercises/notes/test'}
            ]
        },
        {
            label: 'Interwały',
            key: '/exercises/2',
            children: [
                {label: 'Nazwy interwałów', key: '/exercises/intervals'},
                {label: 'Nazwy interwałów. Test', key: '/exercises/intervals/test'},
                {label: 'Interwały melodyczne. Test audio', key: '/exercises/intervals/test/melodic'},
                {label: 'Interwały harmoniczne. Test audio', key: '/exercises/intervals/test/harmonic'},
                {label: 'Przewroty interwałów', key: '/exercises/intervals/inversions'},
                {label: 'Przewroty interwałów. Test', key: '/exercises/intervals/inversions/test'}
            ]
        },
        {
            label: 'Trójdźwięki',
            key: '/exercises/3',
            children: [
                {label: 'Rodzaje trójdźwięków', key: '/exercises/triads'},
                {label: 'Trójdźwięki. Test', key: '/exercises/triads/test'},
                {label: 'Przewroty trójdźwięków', key: '/exercises/triads/inversions'},
                {label: 'Przewroty trójdźwięków. Test', key: '/exercises/triads/inversions/test'}
            ]
        },
        {
            label: 'Skale i gamy',
            key: '/exercises/4',
            children: [
                {label: 'Skala durowa', key: '/exercises/major-scale'},
                {label: 'Skala molowa', key: '/exercises/minor-scale'},
                {label: 'Tonacje', key: '/exercises/keys'},
                {label: 'Tonacje. Test', key: '/exercises/keys/test'}
            ]
        }
    ];
    return <Menu theme="light"
                 selectedKeys={[root, current]}
                 mode="inline"
                 items={items}
                 onClick={onClick}>
    </Menu>;
}

const mapStateToProps = (state) => ({
    settings: state.Settings
});

export default connect(mapStateToProps, {})(ExercisesNavbar);
